module.exports = __webpack_public_path__ + "img/imgDashboard.617336fc.png";